import React, { useState, useEffect } from 'react';
import LearningPage from './LearningPage';
import AdminPanel from './AdminPanel';
import AdminGate from './AdminGate';
import StatsPage from './StatsPage';
import LettersPage from './LettersPage';
import VocabPage from './VocabPage';
import HomePage from './HomePage';
import './App.css';

function getView() {
  const path = window.location.pathname.replace(/\/+$/, '').toLowerCase();
  if (path === '/admin') return 'admin';
  if (path === '/stats') return 'stats';
  if (path === '/letters') return 'letters';
  if (path === '/vocab') return 'vocab';
  if (path === '/quiz') return 'learn';
  return 'home';
}

// Client-side navigation; updates the URL and notifies App to re-render.
export function navigate(path) {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

function App() {
  const [view, setView] = useState(getView);

  useEffect(() => {
    const onPop = () => setView(getView());
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  if (view === 'admin') {
    return (
      <div>
        <AdminGate>
          <AdminPanel />
        </AdminGate>
      </div>
    );
  }

  if (view === 'letters') return <div><LettersPage /></div>;
  if (view === 'vocab') return <div><VocabPage /></div>;
  if (view === 'stats') return <div><StatsPage /></div>;
  if (view === 'learn') return <div><LearningPage /></div>;
  return <div><HomePage /></div>;
}

export default App;
